import React from "react";

export const formatTextWithLinksAndLineBreaks = (text) => {
  if (!text) return '';

  const urlRegex = /\b(?:https?:\/\/|www\.)[^\s<>]+|\b[a-z0-9-]+\.[a-z]{2,}(\/\S*)?/gi;

  let elements = [];
  let lastIndex = 0;

  for (const match of text.matchAll(urlRegex)) {
    const { index } = match;
    const urlText = match[0];

    // Add text before the URL
    const before = text.substring(lastIndex, index);
    if (before) {
      before.split('\n').forEach((line, i, arr) => {
        elements.push(<React.Fragment key={`${lastIndex}-${i}`}>{line}{i < arr.length - 1 && <br />}</React.Fragment>);
      });
    }

    // Add the URL itself
    let url = urlText;
    if (!url.startsWith('http')) {
      url = 'https://' + url;
    }
    elements.push(
      <a key={`link-${index}`} href={url} target="_blank" rel="noopener noreferrer" style={{ color: '#3b82f6' }}>
        {urlText}
      </a>
    );

    lastIndex = index + urlText.length;
  }

  // Add the rest of the text after the last URL
  const remaining = text.substring(lastIndex);
  if (remaining) {
    remaining.split('\n').forEach((line, i, arr) => {
      elements.push(<React.Fragment key={`last-${lastIndex}-${i}`}>{line}{i < arr.length - 1 && <br />}</React.Fragment>);
    });
  }

  return elements;
};
